import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const TeamsIcon = ({
  color = '#96A2C2',
  width = 25,
  height = 50
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    viewBox="0 0 25 25"
    style={{
      fill: color,
      width,
      height //:50
      // fill="#73767D"
    }}
  >
    <path d="M1.015 16.552C1.015 16.552 2.384 13.5 6 13.5C9.6155 13.5 11.015 16.552 11.015 16.552L11 18.5H1L1.015 16.552ZM23 16.5C23 16.5 21.6155 13.5 18 13.5C14.384 13.5 13 16.5 13 16.5V18.5H23V16.5Z" />
    <path d="M6 12.5C4.6185 12.5 3.5 11.381 3.5 10C3.5 8.619 4.6185 7.5 6 7.5C7.3805 7.5 8.5 8.619 8.5 10C8.5 11.381 7.3805 12.5 6 12.5ZM18 12.5C19.381 12.5 20.5 11.381 20.5 10C20.5 8.619 19.381 7.5 18 7.5C16.619 7.5 15.5 8.619 15.5 10C15.5 11.381 16.619 12.5 18 12.5Z" />
    <path d="M15 8C15 9.6575 13.657 11 12 11C10.343 11 9 9.6575 9 8C9 6.3425 10.343 5 12 5C13.6565 5 15 6.343 15 8ZM18 16C18 16 16.307 12.527 11.9675 12.527C7.628 12.527 6 16 6 16V18.5H18V16Z" />
  </IconSvg>
)
// <path d="M0.76125 12.914C0.76125 12.914 1.788 10.625 4.5 10.625C7.21163 10.625 8.26125 12.914 8.26125 12.914L8.25 14.375H0.75L0.76125 12.914ZM17.25 12.875C17.25 12.875 16.2116 10.625 13.5 10.625C10.788 10.625 9.75 12.875 9.75 12.875V14.375H17.25V12.875Z" fill="#73767D"/>
// <path d="M4.5 9.875C3.46387 9.875 2.625 9.03575 2.625 8C2.625 6.96425 3.46387 6.125 4.5 6.125C5.53537 6.125 6.375 6.96425 6.375 8C6.375 9.03575 5.53537 9.875 4.5 9.875ZM13.5 9.875C14.5358 9.875 15.375 9.03575 15.375 8C15.375 6.96425 14.5358 6.125 13.5 6.125C12.4642 6.125 11.625 6.96425 11.625 8C11.625 9.03575 12.4642 9.875 13.5 9.875Z" fill="#73767D"/>
// <path d="M11.25 6.5C11.25 7.74312 10.2428 8.75 9 8.75C7.75725 8.75 6.75 7.74312 6.75 6.5C6.75 5.25688 7.75725 4.25 9 4.25C10.2424 4.25 11.25 5.25725 11.25 6.5ZM13.5 12.5C13.5 12.5 12.2302 9.89525 8.97563 9.89525C5.721 9.89525 4.5 12.5 4.5 12.5V14.375H13.5V12.5Z" fill="#73767D"/>

export default TeamsIcon
